import { render, staticRenderFns } from "./ImageTextSettingRatio.vue?vue&type=template&id=05608866&scoped=true&"
import script from "./ImageTextSettingRatio.vue?vue&type=script&lang=js&"
export * from "./ImageTextSettingRatio.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextSettingRatio.vue?vue&type=style&index=0&id=05608866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05608866",
  null
  
)

export default component.exports